import axios from "../utils/http";
import path from "./path"
import {Base64} from 'js-base64';

const stringFormat = (formatted, args) => {
    for (let i = 0; i < args.length; i++) {
        let regexp = new RegExp('\\{' + i + '\\}', 'gi')
        formatted = formatted.replace(regexp, args[i])
    }
    return formatted
}

const api = {
    get(url, query) {
        if (query) {
            return axios.get(path.baseUrl + url, {params: query})
        }
        return axios.get(path.baseUrl + url)
    },
    getEventTypes() {
        return axios.get(path.baseUrl + path.getEventTypes)
    },
    getUserInfo(query) {
        return axios.get(path.baseUrl + path.userInfo, {params: query})
    },
    login(data) {
        return axios.post(path.baseUrl + path.login, data)
    },
    logout(env) {
        return axios.get(path.baseUrl + stringFormat(path.logout, [env]))
    },
    getOssKeySecret() {
        return axios.get(path.baseUrl + path.getOssKeySecret);
    },
    getH5DashboardData() {
        return axios.get(path.baseUrl + path.getH5DashboardData);
    },
    getLoginCaptchaToken() {
        return axios.get(path.baseUrl + path.loginCaptchaToken);
    },
    getListFilter(filterType, query) {
        return axios.get(path.baseUrl + path.filters[filterType], {params: query})
    },
    getStatisticData(query) {
        return axios.get(path.baseUrl + path.getStatisticData, {params: query})
    },
    getWechatRedirectUrl(url) {
        return axios.get(path.baseUrl + stringFormat(path.getWechatRedirectUrl, [Base64.encode(url)]))
    },
    wechatCodeLogin(code) {
        return axios.get(path.baseUrl + stringFormat(path.wechatCodeLogin, [code]))
    },
    applySmsCaptcha(phone) {
        return axios.get(path.baseUrl + stringFormat(path.applySmsCaptcha, [phone]))
    },
    applySmsBind(data) {
        return axios.get(path.baseUrl + path.applySmsBind, {params: data})
    },
    getInfiniteLoadingList(i, method, query) {
        if ('GET' == method) {
            return axios.get(path.baseUrl + path.infiniteLoadings[i], {params: query})
        }
        return axios.post(path.baseUrl + path.infiniteLoadings[i], query)
    },
    getAgentSaleId(goodId) {
        return axios.get(path.baseUrl + stringFormat(path.getAgentSaleId, [goodId]))
    },
    getSaleGood(lessonId) {
        return axios.get(path.baseUrl + stringFormat(path.getSaleGood, [lessonId]))
    },
    getRecentOrderList(goodId) {
        return axios.get(path.baseUrl + stringFormat(path.getRecentOrderList, [goodId]))
    },
    createPayOrder(order) {
        return axios.post(path.baseUrl + path.createPayOrder, order)
    },
    getSaleOrder(orderId) {
        return axios.get(path.baseUrl + stringFormat(path.getSaleOrder, [orderId]))
    },
    updateSaleOrderInfo(detail) {
        return axios.post(path.baseUrl + path.updateSaleOrderInfo, detail)
    },
    getPersonalAgentReportDetail(query) {
        return axios.get(path.baseUrl + path.getPersonalAgentReportDetail, {params: query})
    },
    getSaleCategory() {
        return axios.get(path.baseUrl + path.getSaleCategory)
    },
    confirmInnerLianLianPay(query) {
        return axios.get(path.baseUrl + path.confirmInnerLianLianPay, {params: query})
    },
    getOpenSaleOrder(query) {
        return axios.get(path.baseUrl + path.getOpenSaleOrder, {params: query})
    },
    getPasswordToken(query) {
        return axios.get(path.baseUrl + path.getPasswordToken, {params: query})
    },
    queryAccount(query) {
        return axios.get(path.baseUrl + path.queryAccount, {params: query})
    },
    submitApplyWithdraw(query) {
        return axios.get(path.baseUrl + path.submitApplyWithdraw, {params: query})
    },
    submitSmsVerify(query) {
        return axios.get(path.baseUrl + path.submitSmsVerify, {params: query})
    },
    getOpenLLPAccountLink() {
        return axios.get(path.baseUrl + path.getOpenLLPAccountLink)
    },
    submitRealName4Withdraw(data) {
        return axios.post(path.baseUrl + path.submitRealName4Withdraw, data)
    },
    getAgentList() {
        return axios.get(path.baseUrl + path.getAgentList)
    },
    getGoodList4Select(query) {
        return axios.get(path.baseUrl + path.getGoodList4Select,{params: query})
    },
    getBalancePayConfig(query) {
        return axios.get(path.baseUrl + path.getBalancePayConfig,{params: query})
    },
    submitPaySmsVerify(query) {
        return axios.get(path.baseUrl + path.balancePaySmsVerify,{params: query})
    },
    getAgentSaleOrder(query) {
        return axios.get(path.baseUrl + path.getAgentSaleOrder,{params: query})
    },
    refundSaleOrder(data) {
        return axios.post(path.baseUrl + path.refundSaleOrder, data)
    },
    getSkuInfo(skuId) {
        return axios.get(path.baseUrl + stringFormat(path.getSkuInfo, [skuId]))
    },
    submitForgetPassword(query) {
        return axios.get(path.baseUrl + path.submitForgetPassword,{params: query})
    },
    submitResetPayPassSmsVerify(data) {
        return axios.post(path.baseUrl + path.submitResetPayPassSmsVerify, data)
    },
    getPasswordInputToken(scene) {
        return axios.get(path.baseUrl + stringFormat(path.getPasswordInputToken, [scene]))
    },
    confirmShareProfit(data) {
        return axios.post(path.baseUrl + path.confirmShareProfit, data)
    },
    confirmShareProfitRollback(data) {
        return axios.post(path.baseUrl + path.profitSharingRollback, data)
    },
    getEnumOptions(query) {
        return axios.get(path.baseUrl + path.getEnumOptions,{params: query})
    },
    auditRefund(data) {
        return axios.post(path.baseUrl + path.auditRefund, data)
    },
    getCorpBalance(query) {
        return axios.get(path.baseUrl + path.getCorpBalance,{params: query})
    },
    getRefundHistory(orderId) {
        return axios.get(path.baseUrl + stringFormat(path.getRefundHistory, [orderId]))
    }
}

export default api;